import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {takeUntil} from "rxjs/operators";
import {MatTabChangeEvent} from "@angular/material/tabs";
import {HttpErrorResponse} from "@angular/common/http";
import {CompetitionImportRow} from "../../../shared/interface/competition-import-row";
import {CompetitionImportService} from "../../../shared/services/competition-import.service";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";
import {Document} from "../../../shared/interface/document";
import {ListResponse} from "../../../shared/interface/response/list-response";
import {DocumentAddDialogComponent} from "../../documents/document-add-dialog/document-add-dialog.component";
import {FILE_TYPE_AWARD_RECEPTION_PROTOCOL} from "../../../shared/services/dict.service";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-competition-import-row-details',
  templateUrl: './competition-import-row-details.component.html',
  styleUrls: ['./competition-import-row-details.component.scss']
})
export class CompetitionImportRowDetailsComponent implements OnInit, OnDestroy {
  uuid?: string = null;
  participantObject?: CompetitionImportRow;
  competitionImportRow: ReplaySubject<CompetitionImportRow> = new ReplaySubject<CompetitionImportRow>(1);
  competitionParticipant: ReplaySubject<CompetitionImportRow> = new ReplaySubject<CompetitionImportRow>(1);
  modify = false;
  userPermissions: ReplaySubject<UserPermissions>;
  documents: ReplaySubject<Document[]> = new ReplaySubject<Document[]>(1);


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private route: ActivatedRoute,
    private competitionService: CompetitionImportService,
    private snack: MatSnackBar,
    private auth: AuthService,
    private dialog: MatDialog,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }
  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.uuid = params.id;
        this.loadImportRow();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onTabChange(e: MatTabChangeEvent): void {
    if (e.index === 0) {
      this.loadImportRow();
    }
    if (e.index === 1) {
      this.loadDocuments();
    }
  }

  loadImportRow(): void {
    this.competitionService.getCompetitionImportRow(this.uuid).subscribe((competitionParticipant: CompetitionImportRow) => {
      this.competitionParticipant.next(competitionParticipant);
      this.competitionImportRow.next(competitionParticipant);
      this.participantObject = competitionParticipant;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych', error.status.toString(), {
        duration: 2000
      });
    });
  }

  loadDocuments(): void {
    this.competitionService.getCompetitionImportRowDocuments(this.uuid)
      .subscribe((documents: ListResponse<Document>) => {
        this.documents.next(documents.items);
      });
  }

  addDocument(): void {
    const dialogRef = this.dialog.open(DocumentAddDialogComponent, {
      width: '55%',
      data: {
        competitionImportRowObject: this.participantObject,
        types: [FILE_TYPE_AWARD_RECEPTION_PROTOCOL],
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadDocuments();
    });
  }
}
